import { DECIMAL } from '@belimo-retrofit-portal/logic';
import * as C from 'io-ts/Codec';
import { createSelector } from 'reselect';
import { decodeOrThrow } from 'src/io/utils/decodeOrThrow';
import { BasedataFormData } from 'src/modules/basedata/types/BasedataFormData';
import { Project } from 'src/modules/common/types/Project';
import { ProjectSettings } from 'src/modules/common/types/ProjectSettings';
import { getProjectDetails } from 'src/modules/project-view/selectors/getProjectDetails';
import { getProjectSettings } from 'src/modules/project-view/selectors/getProjectSettings';

const mapProjectDetails = (project: Project, settings: ProjectSettings): BasedataFormData => ({
  cover: project.data.cover,
  title: project.data.title,
  building: project.data.building,
  participants: project.data.participants,
  projectGoals: project.data.goals,
  status: project.data.status,
  statusComment: project.data.statusComment,
  annualSaving: decodeOrThrow(C.nullable(DECIMAL), settings.annualSaving || null),
});

export const getBasedataFormData = createSelector(
  [getProjectDetails, getProjectSettings],
  mapProjectDetails,
);
